<template>
  <!--下拉详情-->
  <div class="main">
    <section class="main-wrap">
      <el-row align="middle" class="main-item">
        <el-col :span="8" class="address">
          公司名称：<span>{{ details.companyName }}</span>
        </el-col>
        <el-col :span="8" class="address">
          员工姓名：<span>{{ details.realName }}</span>
        </el-col>
      </el-row>
      <el-row align="middle" class="main-item">
        <el-col :span="8" class="address" style="vertical-align:middle;">
<!--          <img style="width: 25px;height: 25px; border-radius: 50%; vertical-align:middle;" src="../../../../assets/img/homeIcon.png" alt=""> --> 
          昵称：<span>{{ details.nickName }}</span>
        </el-col>
        <el-col :span="8" class="address">
          用户名：<span> {{ details.userName }}</span>
        </el-col>
        <el-col :span="8" class="address">
          最后修改时间：<span>{{ details.updateDate }}</span>
        </el-col>
      </el-row>
      <el-row align="middle" class="main-item">
        <el-col :span="8" class="address">
          职业类型：<span>{{ details.userPostName }}</span>
        </el-col>
        <el-col :span="8" class="address">
          联系电话：<span>{{ details.phone }}</span>
        </el-col>
        <el-col :span="8" class="address">
          权限级别：<span>{{ details.isAdmingValue }}</span>
        </el-col>
      </el-row>
      <!--<el-row align="middle" class="main-item">
        <el-col class="address">
          最后修改时间：<span>{{ details.updateDate }}</span>
        </el-col>
      </el-row>-->
      <el-row align="middle" class="main-item">

        <el-col v-if="details.userType==2" :span="8" class="address">
          身份证号：<span>{{ details.idCard }}</span>
        </el-col>
        <el-col :span="8" class="address">
          备注：<span>{{ details.remarks }}</span>
        </el-col>
      </el-row>
    </section>
  </div>
</template>

<script>
export default {
  props: {
    // 用户详情
    details: {
      type: Object,
      default: () => {}
    }
  }
}
</script>

<style scoped lang='scss'>
  @keyframes show {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
  .main-wrap{
    padding: 25px 20px 0px 20px;
    border-top: 1px solid #DBDDE1;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    transition: all 0.8s ease-in-out;
    animation: show 0.8s ease-in-out;

    .main-item{
      font-size: 14px;
      padding-bottom: 25px;
    }
    .seeContacts{
      .seeContacts-header{
        color: #BF2316;
        font-size: 15px;
        height: 40px;
        line-height: 40px;
      }
      .seeContacts-table{
        .seeContacts-con{
          font-size: 14px;
          height: 60px;
          line-height: 60px;
          border-bottom: 1px dashed #A6A6A6;
          &:last-child{
            border-bottom: none;
          }
        }
        .seeContacts-table-dc{
          color: #0D63D9;
          cursor: pointer;
        }
      }
    }

  }
</style>
